<template>
    <div class="Columns row">
        <div class="col-md-6">
            <div class="Calendar">
                <div class="Calendar__key">
                    <div class="Calendar__key-item" v-if="type === 'any' || type === 'training'">
                        <div class="Calendar__marker Calendar__marker--training"></div>
                        <span>Training</span>
                    </div>
                    <div class="Calendar__key-item" v-if="type === 'any' || type === 'events'">
                        <div class="Calendar__marker Calendar__marker--event"></div>
                        <span>Meetings/Events</span>
                    </div>
                </div>

                <div class="Calendar__header">
                    <a href="#"
                       :class="{'Calendar__control':true, 'Calendar__control--previous': true, 'Calendar__control--disabled': isCurrentMonth }"
                       @click.prevent="previousMonth()"
                    >
                        <i class="fa fa-chevron-left"></i>
                    </a>

                    <div class="Calendar__selected-month">
                        {{ selectedMonth }}
                    </div>

                    <a href="#" class="Calendar__control Calendar__control--next" @click.prevent="nextMonth()">
                        <i class="fa fa-chevron-right"></i>
                    </a>
                </div>

                <div class="Calendar__grid">
                    <div class="Calendar__row">
                        <div class="Calendar__column Calendar__column--day">Mon</div>
                        <div class="Calendar__column Calendar__column--day">Tue</div>
                        <div class="Calendar__column Calendar__column--day">Wed</div>
                        <div class="Calendar__column Calendar__column--day">Thu</div>
                        <div class="Calendar__column Calendar__column--day">Fri</div>
                        <div class="Calendar__column Calendar__column--day">Sat</div>
                        <div class="Calendar__column Calendar__column--day">Sun</div>
                    </div>
                    <div class="Calendar__row" v-for="row in days">
                        <div :class="columnClasses(day)" v-for="day in row" @click="selectDay(day)">
                            {{ day.date }}
                            <div class="Calendar__events">
                                <div :class="'Calendar__marker Calendar__marker--' + event"
                                     v-for="event in events[day.date]"
                                     v-if="! day.isPast"
                                ></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-6">
            <div class="CalendarList">
                <h2 class="CalendarList__heading">{{ selectedMonth }} Dates</h2>
                <ul class="CalendarList__menu">
                    <li v-for="event in eventList">
                        <a :href="eventLink(event)" class="CalendarList__item CalendarList__item--link" v-if="eventLink(event)">
                            <span :class="'CalendarList__link-text CalendarList__link-text--' + event.type">
                                {{ event.name }}
                            </span>
                        </a>

                        <div class="CalendarList__item" v-else>
                            <span :class="'CalendarList__link-text CalendarList__link-text--' + event.type">
                                {{ event.name }}
                            </span>
                        </div>
                    </li>
                </ul>

                <!--<a href="#" class="LatestNews__button">-->
                    <!--See More Dates for your Diary-->
                <!--</a>-->
            </div>
        </div>
    </div>
</template>

<script>
    import startOfMonth from 'date-fns/start_of_month';
    import endOfMonth from 'date-fns/end_of_month';
    import getDay from 'date-fns/get_iso_day';
    import getDaysInMonth from 'date-fns/get_days_in_month';
    import addMonths from 'date-fns/add_months';
    import subMonths from 'date-fns/sub_months'
    import format from 'date-fns/format';
    import isSameMonth from 'date-fns/is_same_month';
    import getYear from 'date-fns/get_year';
    import getMonth from 'date-fns/get_month';
    import isPast from 'date-fns/is_past';
    import isToday from 'date-fns/is_today';

    export default {
        data() {
            return {
                days: [],
                events: [],
                eventList: [],
                currentMonth: null,
                selectedDate: null,
                daysInMonth: null,
                daysWithOffets: null,
                offsets: {
                    start: null,
                    end: null,
                },

                selectedDay: null,

                isLoading: false,
            }
        },

        props: {
            type: {
                type: String,
                default: 'any'
            }
        },

        mounted() {
            this.initialise();
        },

        computed: {
            selectedMonth() {
                return this.selectedDate ? format(this.selectedDate, 'MMMM YYYY') : '';
            },

            isCurrentMonth() {
                return this.currentMonth ? isSameMonth(this.currentMonth, this.selectedDate) : true;
            }
        },

        methods: {
            columnClasses(day) {
                return {
                    'Calendar__column': true,
                    'Calendar__column--past': day.isPast,
                    'Calendar__column--today': day.isToday,
                    'Calendar__column--no-events': ! _.has(this.events, day.date),
                    'Calendar__column--selected': day === this.selectedDay,
                }
            },

            initialise() {
                this.currentMonth = startOfMonth(new Date());
                this.selectedDate = this.currentMonth;
                this.setMonth();
            },

            createDays() {
                let days = [];

                for (let i = 1; i <= this.daysWithOffets; i++) {
                    let day = { date: '', isPast: true, isToday: false };

                    if (i > this.offsets.start && i <= this.daysInMonth + this.offsets.start) {
                        day.date = i - this.offsets.start;
                        day.isPast = isPast(new Date(getYear(this.selectedDate), getMonth(this.selectedDate), i - this.offsets.start + 1));
                        day.isToday = isToday(new Date(getYear(this.selectedDate), getMonth(this.selectedDate), i  - this.offsets.start))
                    }

                    days.push(day);
                }

                this.days = _.chunk(days, 7);
            },

            setMonth() {
                this.daysInMonth = getDaysInMonth(this.selectedDate);
                this.offsets.start = getDay(startOfMonth(this.selectedDate)) - 1;
                this.offsets.end = 7 - getDay(endOfMonth(this.selectedDate));
                this.daysWithOffets = this.daysInMonth + this.offsets.start + this.offsets.end;
                this.createDays();
                this.getEvents();
                this.getList();
            },

            getEvents() {
                this.isLoading = true;
                this.events = [];

                this.$http.post('/external/dates/calendar', {
                    year: getYear(this.selectedDate),
                    month: getMonth(this.selectedDate) + 1,
                    type: this.type
                })
                    .then(response => {
                        this.events = response.data;
                        this.isLoading = false;
                    });
            },

            getList() {
                this.$http.post('/external/dates/list', {
                    year: getYear(this.selectedDate),
                    month: getMonth(this.selectedDate) + 1,
                    day: this.selectedDay ? this.selectedDay.date : null,
                    type: this.type,
                })
                    .then(response => {
                        this.eventList = response.data;
                    });
            },

            previousMonth() {
                if (this.isCurrentMonth || this.isLoading) return;

                this.selectedDate = subMonths(this.selectedDate, 1);
                this.selectedDay = null;
                this.setMonth();
            },

            nextMonth() {
                if (this.isLoading) return;

                this.selectedDate = addMonths(this.selectedDate, 1);
                this.selectedDay = null;
                this.setMonth();
            },

            selectDay(day) {
                if (day.isPast || ! _.has(this.events, day.date)) return;

                this.selectedDay = day === this.selectedDay ? null : day;
                this.getList();
            },

            eventLink(event) {
                if (event.type === 'event') return event.link;

                return '/training-and-events/training/training-courses/' + event.link;
            }
        }
    }
</script>